import { Col, Divider, Form, Input, notification, Row, Select } from 'antd';
import MaskedInput from 'antd-mask-input';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';

import StrongPass from '../../../components/StrongPassword';
import { filterOption } from '../../../helpers/form';
import { Estados } from '../../../helpers/uf';
import { comboPerfil } from '../../../helpers/user';
import { useAuth } from '../../../security/authContext';
import apiCep, { apiIBGE } from '../../../services/apiEnderecos';

export default function InfoUsuario({
  form,
  setClientePerfil,
  setIsValidPass,
  setPass,
  required,
  validateForm,
  isEditingUser,
}) {
  const { getFieldValue, setFieldsValue } = form;
  const [cidades, setCidades] = useState([]);
  const [loadingCidade, setLoadingCidade] = useState(false);
  const [isUserPerfilSotranLogado, setIsUserPerfilSotranLogado] = useState(
    false
  );

  const { user } = useAuth();

  const handleChangeEstado = async isCep => {
    setLoadingCidade(true);

    try {
      const uf = getFieldValue('estadoUsuario');
      if (uf) {
        const estadoSelecionado = Estados.filter(
          estado => estado.sigla === uf
        ).reduce(result => result);

        if (estadoSelecionado) {
          const { data } = await apiIBGE.get(
            `estados/${estadoSelecionado.id}/municipios`
          );
          setCidades(data);

          if (!isCep) {
            setFieldsValue({
              cidadeUsuario: undefined,
            });
          }
        }
      }
      validateForm();
    } catch (e) {
      notification.error({
        message: 'Ops, não foi possível recuperar as cidades',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    }
    setLoadingCidade(false);
  };

  const handlePerfil = async value => {
    setClientePerfil(value === 'CLIENTE');
  };

  const handleChangeCep = async () => {
    try {
      const cep = getFieldValue('cepUsuario');
      if (cep && cep.length > 8) {
        const response = await apiCep.get(`${cep}/json`);

        if (!response.data.erro) {
          setFieldsValue({
            cidadeUsuario: response.data.localidade,
            lograUsuario: response.data.logradouro,
            bairroUsuario: response.data.bairro,
            estadoUsuario: response.data.uf,
          });
          handleChangeEstado(true);
        }
      }
    } catch (e) {
      notification.error({
        message: 'Ops, não foi possível recuperar as informações do endereço',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    }
  };

  useEffect(() => {
    async function onInit() {
      if (user.profile === 'SOTRAN') {
        setIsUserPerfilSotranLogado(true);
      }
    }
    onInit();
  }, [isUserPerfilSotranLogado, isEditingUser]);

  return (
    <>
      <Divider orientation="left">Informações do usuário</Divider>
      <Row gutter={12}>
        <Col xs={10} lg={10} xl={10}>
          <Form.Item
            name="perfilUsuario"
            rules={[
              {
                required: true,
                message: 'Por favor, selecione um perfil!',
              },
            ]}
            label="Perfil"
            labelAlign="right"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
          >
            <Select
              className="total-width"
              disabled={!isUserPerfilSotranLogado}
              showSearch
              filterOption={(value, { title }) => filterOption(value, title, 0)}
              onChange={value => handlePerfil(value)}
            >
              {comboPerfil.map(perfil => (
                <Select.Option
                  key={perfil.id}
                  title={perfil.desc}
                  value={perfil.id}
                >
                  {perfil.desc}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={13} lg={13} xxl={13} xl={13} offset={1}>
          <Form.Item
            name="cpfUsuario"
            rules={[{ required: true, message: 'Por favor, insira um cpf!' }]}
            label="CPF"
            labelAlign="right"
            labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
          >
            <MaskedInput className="total-width" mask="111.111.111-11" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col xs={10} lg={10} xl={10}>
          <Form.Item
            name="nomeUsuario"
            rules={[{ required: true, message: 'Por favor, insira um nome!' }]}
            label="Nome"
            labelAlign="right"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
          >
            <Input className="total-width" />
          </Form.Item>
        </Col>
        <Col xs={13} lg={13} xxl={13} xl={13} offset={1}>
          <Form.Item
            name="emailUsuario"
            rules={[{ required: true, message: 'Por favor, insira um email!' }]}
            label="Email"
            labelAlign="right"
            labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
          >
            <Input
              type="email"
              className="total-width"
              onBlur={e => {
                setFieldsValue({
                  loginUsuario: e.target.value,
                });
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col xs={10} lg={10} xl={10}>
          <Form.Item
            name="celUsuario"
            rules={[
              {
                required: true,
                message: 'Por favor, insira um número de celular!',
              },
            ]}
            label="Celular"
            labelAlign="right"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
          >
            <MaskedInput className="total-width" mask="(11) 1 1111-1111" />
          </Form.Item>
        </Col>
        <Col xs={13} lg={13} xxl={13} xl={13} offset={1}>
          <StrongPass
            requisitos={['M', 'm', '9']}
            setIsValidPass={setIsValidPass}
            setPass={setPass}
            required={required}
            formProps={Form.Item}
            labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
            labelAlign="right"
            label="Senha"
          />
        </Col>
      </Row>
      <Row gutter={10}>
        <Col xs={10} lg={10} xl={10}>
          <Form.Item
            name="loginUsuario"
            rules={[
              { required: true, message: 'Por favor, insira um login!' },
              {
                pattern: /^[^\\:]*$/,
                message: 'O caracter dois pontos não é aceito neste cadastro',
              },
            ]}
            label="Login"
            labelAlign="right"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
          >
            <Input className="total-width" />
          </Form.Item>
        </Col>
        <Col xs={13} lg={13} xl={13} offset={1}>
          <Form.Item
            name="passConfirm"
            rules={[{ required, message: 'Por favor, confirme a senha!' }]}
            label="Confirmar senha"
            labelAlign="right"
            labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
          >
            <Input.Password
              className="total-width"
              autoComplete="new-password"
              placeholder="*****"
            />
          </Form.Item>
        </Col>
      </Row>

      <Divider orientation="left">Informações de endereço do usuário</Divider>
      <Row gutter={12}>
        <Col xs={10} lg={10} xl={10} xxl={10}>
          <Form.Item
            name="cepUsuario"
            rules={[{ required: true, message: 'Por favor, insira um cep!' }]}
            label="Cep"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
            labelAlign="right"
          >
            <MaskedInput
              className="total-width"
              onBlur={handleChangeCep}
              mask="11111-111"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={10} lg={10} xl={10}>
          <Form.Item
            name="lograUsuario"
            rules={[
              {
                required: true,
                message: 'Por favor, insira um endereço!',
              },
            ]}
            label="Endereço"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
            labelAlign="right"
          >
            <Input className="total-width" />
          </Form.Item>
        </Col>
        <Col xs={13} lg={13} xl={13} offset={1}>
          <Form.Item
            name="numLograUsuario"
            initialValue={0}
            label="Número"
            labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
            labelAlign="right"
          >
            <NumberFormat className="total-width" customInput={Input} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={10} lg={10} xl={10}>
          <Form.Item
            name="bairroUsuario"
            rules={[
              {
                required: true,
                message: 'Por favor, insira um bairro!',
              },
            ]}
            label="Bairro"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
            labelAlign="right"
          >
            <Input className="total-width" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={10} lg={10} xl={10}>
          <Form.Item
            name="estadoUsuario"
            rules={[
              {
                required: true,
                message: 'Por favor, selecione um Estado!',
              },
            ]}
            label="Estado"
            labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
            labelAlign="right"
          >
            <Select
              className="total-width"
              showSearch
              allowClear
              filterOption={(value, { title }) => filterOption(value, title, 0)}
              onChange={() => handleChangeEstado(false)}
            >
              {Estados.map(uf => (
                <Select.Option key={uf.sigla} title={uf.nome} value={uf.sigla}>
                  {uf.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={13} lg={13} xl={13} offset={1}>
          <Form.Item
            name="cidadeUsuario"
            rules={[
              {
                required: true,
                message: 'Por favor, selecione uma cidade!',
              },
            ]}
            label="Cidade"
            labelAlign="right"
            labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
          >
            <Select
              loading={loadingCidade}
              className="total-width"
              showSearch
              allowClear
              filterOption={(value, { title }) => filterOption(value, title, 0)}
            >
              {cidades.map(cidade => (
                <Select.Option
                  key={cidade.id}
                  title={cidade.nome}
                  value={cidade.nome}
                >
                  {cidade.nome}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

InfoUsuario.propTypes = {
  form: PropTypes.shape({
    getFieldValue: PropTypes.func,
    setFieldsValue: PropTypes.func,
  }).isRequired,
  validateForm: PropTypes.func.isRequired,
  setClientePerfil: PropTypes.func.isRequired,
  setIsValidPass: PropTypes.func.isRequired,
  setPass: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  isEditingUser: PropTypes.bool,
};

InfoUsuario.defaultProps = {
  isEditingUser: false,
};
